import { money } from "@/lib/totals";

export function ItemsGrid({ lines, selectedId, onSelect, onEditPrice }) {
  return (
    <div className="grid-wrap" data-testid="items-grid">
      <table className="items-table">
        <thead>
          <tr>
            <th>Item ID</th>
            <th>Item name alias</th>
            <th className="num">Quantity</th>
            <th className="num">Original Price</th>
            <th className="num">Tax Amount</th>
            <th className="num">Total (with tax)</th>
          </tr>
        </thead>
        <tbody>
          {lines.length === 0 && (
            <tr>
              <td colSpan={6} className="empty-cart">
                Scan a barcode or add an item to begin a new bill.
              </td>
            </tr>
          )}
          {lines.map((l) => {
            const lineTotal = l.price * l.qty;
            const tax = (lineTotal * l.tax_rate) / (100 + l.tax_rate);
            return (
              <tr
                key={l.line_id}
                className={l.line_id === selectedId ? "sel" : ""}
                onClick={() => onSelect(l.line_id)}
                data-testid={`item-row-${l.line_id}`}
              >
                <td>{l.barcode}</td>
                <td>{l.item_alias}</td>
                <td className="num" data-testid={`item-qty-${l.line_id}`}>
                  {l.qty}
                </td>
                <td
                  className="num price-cell"
                  onDoubleClick={(e) => {
                    e.stopPropagation();
                    onEditPrice(l);
                  }}
                  title="Double-click to edit price"
                  data-testid={`item-price-${l.line_id}`}
                >
                  {money(l.price)}
                </td>
                <td className="num">{money(tax)}</td>
                <td className="num">{money(lineTotal)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
